import React from "react";
import { Q } from "../constants/testIds";

export const CompletionScreen = ({ onRestart }) => {
  return (
    <div className="gw-card gw-fade-up" data-testid={Q.completionScreen}>
      <div className="flex flex-col gap-6">
        <div className="flex items-center gap-2">
          <span className="gw-small" style={{ color: "var(--success)" }}>
            Saved
          </span>
        </div>

        <hr className="gw-divider" />

        <div className="flex flex-col gap-3">
          <h1 className="gw-headline">Setup profile created.</h1>
          <p className="gw-body">Your answers have been saved.</p>
        </div>

        <button
          type="button"
          className="gw-btn-secondary w-full"
          onClick={onRestart}
          data-testid={Q.restartBtn}
        >
          Start over
        </button>
      </div>
    </div>
  );
};

export default CompletionScreen;
